module.exports = __webpack_public_path__ + "static/media/telegrambw.bcb5cdae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/blocks/socialButtons/static/img/social/telegrambw.svg
// module id = 2068
// module chunks = 118